import React from 'react';
import PropTypes from 'prop-types';
import { LabelLinkWrapperExt, LabelLinkWrapperInt, LinkWrapper } from './styles';
import Label from '../Label';
import IconFont from '../IconFont';

const LabelLink =
  ({
    label, color, size, path, isInternal, margin, weight, hideArrow, isForm, isTitleNarrowMedium, rotate, font, isGazzanet,
  }) => (
    <LinkWrapper isForm={isForm}>
      {isInternal ? (
          label &&
          <LabelLinkWrapperInt to={path} rotate={rotate}>
            <Label
              color={color}
              size={size}
              label={label}
              weight={weight}
              isTitleNarrowMedium={isTitleNarrowMedium}
              font={font}
            />
            {!hideArrow &&
            <IconFont
              className="icon-matchcenter-right-arrow"
              color={color}
              font={10}
              marginLeft={0.3}
              weight="bold"
              withCursor
              rotate={rotate}
            />
            }
          </LabelLinkWrapperInt>
        )
        : (
          (!isGazzanet) ?
            <LabelLinkWrapperExt href={path} rotate={rotate} margin={margin}>
              <Label
                margin={margin}
                color={color}
                size={size}
                font={font}
                label={label}
                weight={weight}
                isTitleNarrowMedium={isTitleNarrowMedium}
              />
              {!hideArrow &&
              <IconFont
                className="icon-matchcenter-right-arrow"
                color={color}
                font={10}
                marginLeft={0.3}
                weight="bold"
                withCursor
                rotate={rotate}
              />
              }
            </LabelLinkWrapperExt>
          : <Label margin={margin} color={color} size={size} font={font} label={label} weight={weight} isTitleNarrowMedium={isTitleNarrowMedium} />
        )
      }
    </LinkWrapper>
  );


LabelLink.propTypes = {
  label: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.number,
  path: PropTypes.any,
  isInternal: PropTypes.any,
  weight: PropTypes.string,
  hideArrow: PropTypes.bool,
  isForm: PropTypes.bool,
  isTitleNarrowMedium: PropTypes.any,
  rotate: PropTypes.any,
  margin: PropTypes.any,
  font: PropTypes.any,
  isGazzanet: PropTypes.any,
};

export default LabelLink;



// WEBPACK FOOTER //
// ./src/components/shared/LabelLink/index.js